module.exports = __webpack_public_path__ + "img/chinesecompany129.b97ee079.png";